import { render, staticRenderFns } from "./SearchPhrasesWithNoResults.vue?vue&type=template&id=7c483769"
import script from "./SearchPhrasesWithNoResults.vue?vue&type=script&lang=js"
export * from "./SearchPhrasesWithNoResults.vue?vue&type=script&lang=js"
import style0 from "./SearchPhrasesWithNoResults.vue?vue&type=style&index=0&id=7c483769&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports